export const iconFontAwesomeShoppingShopLock = (
	<i className="fa-solid fa-shop-lock"></i>
);
